import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/apps";

import Title from "../components/common/Title";
import AppFrame from "./AppFrame";
import layout from "../styles/layout";

import { stateToHTML } from "draft-js-export-html";
import RichTextEditor from "react-rte";
import {
  getTextAlignBlockMetadata,
  getTextAlignClassName,
  getTextAlignStyles,
} from "./playbook/library/blockStyleFunctions";
import NormalTextField from "../components/common/NormalTextField";
import { Button, TextField } from "@material-ui/core";

import AppSettingsService from "../services/appSettings";

import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  convertFromHTML,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import colors from "../styles/colors";
import { omit } from "lodash";

const style = {
  editButton: {
    position: "absolute",
    top: 20,
    right: 20,
  },
};

const toolbarConfig = {
  display: [
    "INLINE_STYLE_BUTTONS",
    "BLOCK_TYPE_BUTTONS",
    "BLOCK_TYPE_DROPDOWN",
    "LINK_BUTTONS",
  ],
  INLINE_STYLE_BUTTONS: [
    { label: "Bold", style: "BOLD", className: "custom-css-class" },
    { label: "Italic", style: "ITALIC" },
    { label: "Underline", style: "UNDERLINE" },
  ],
  BLOCK_TYPE_DROPDOWN: [
    { label: "Normal", style: "unstyled" },
    { label: "Heading Large", style: "header-one" },
    { label: "Heading Medium", style: "header-two" },
    { label: "Heading Small", style: "header-three" },
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: "UL", style: "unordered-list-item" },
    { label: "OL", style: "ordered-list-item" },
  ],
};

const draftToolsConfig = {
  options: [
    "inline",
    "blockType",
    "fontSize",
    "fontFamily",
    "list",
    "textAlign",
    "colorPicker",
    "link",
    "remove",
    "history",
  ],
};

class EditAppWelcomeEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      appId: props.apps.providerAppId,
      subject: "",
      emailIntro: "",
      appleUrl: "",
      androidUrl: "",
      portalUrl: "",
      logoUrl: "",
      appName: "",
      appPublishedName: "",
      draftEditorState: EditorState.createEmpty(),
    };

    this.saveAndGoBack = this.saveAndGoBack.bind(this);
    this.onDraftEditorStateChange = this.onDraftEditorStateChange.bind(this);
  }

  componentWillMount() {
    AppSettingsService()
      .getAppEmailSettings(this.state.appId)
      .then((resp) => {
        //Create editor state from html in DB
        const blocksFromHtml = convertFromHTML(resp.emailIntro);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(
          contentBlocks,
          entityMap
        );
        const editorState = EditorState.createWithContent(contentState);

        this.setState({
          loaded: true,
          subject: resp.subject,
          draftEditorState: editorState,
          appName: resp.appName,
          author: resp.author,
          appPublishedName: resp.appPublishedName,
          logoUrl: resp.logoUrl,
          androidUrl: resp.androidUrl,
          appleUrl: resp.appleUrl,
          portalUrl: resp.portalUrl,
        });
      })
      .catch((exception) => {
        this.setState({ error: "Unable to load custom email template." });
      });
  }

  componentWillReceiveProps(nextProps) {}

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  onDraftEditorStateChange = (draftEditorState) => {
    this.setState({
      draftEditorState,
    });
  };

  saveEmailChanges() {
    //editorState.toString("html", {
    //    blockStyleFn: getTextAlignStyles,
    //}),
  }
  saveAndGoBack() {
    const curState = convertToRaw(this.state.draftEditorState.getCurrentContent());
    const hashConfig = {
      trigger: "#",
      separator: " ",
    };

    const markup = draftToHtml(curState, hashConfig);

    AppSettingsService()
      .updateCustomEmailTemplate(this.state.appId, this.state.subject, markup)
      .then((response) => {
        alert("Email template updated successfully");
        setTimeout(() => {
          this.props.history.goBack();
        }, 1000);
      });
  }

  render() {
    return (
      <AppFrame
        auth={this.props.auth}
        header="Edit App Welcome Email"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <Title
          text1="Edit App Welcome Email"
          goBack={() => this.props.history.goBack()}
        />
        <p style={{ margin: 20 }}>
          Customize the subject and introduction to the system welcome email.
          Welcome emails are sent to new clients as they are added to the
          system.
        </p>
        <div
          style={{
            borderWidth: 1,
            borderStyle: "solid",
            borderRadius: 7,
            margin: 20,
            padding: 10,
          }}
        >
          <div
            style={{
              width: "90%",
              marginLeft: "auto",
              marginRight: "auto",
              marginBottom: 20,
            }}
          >
            <TextField
              variant="outlined"
              placeholder="Subject"
              value={this.state.subject}
              onChange={(event) => {
                this.setState({ subject: event.target.value });
              }}
              style={{ fontSize: 14, width: "100%" }}
            />
          </div>
          <div
            style={{
              clear: "both",
              width: "100%",
              textAlign: "center",
              marginBottom: 20,
            }}
          >
            <img
              src={this.state.logoUrl}
              alt="Channel Logo"
              style={{ textAlign: "center", width: 300 }}
            />
          </div>
          <div
            style={{
              fontFamily: "Arial, Helvetica, sans-serif",
              fontSize: 16,
              color: "#696969",
              width: "90%",
              marginLeft: "auto",
              marginRight: "auto",
              padding: 0,
            }}
          >
            <Editor
              editorState={this.state.draftEditorState}
              toolbarClassName="toolbarClassName"
              toolbar={{
                options: [
                  "inline",
                  "blockType",
                  "fontSize",
                  "fontFamily",
                  "list",
                  "textAlign",
                  "history",
                ],
                inline: { inDropdown: true },
                list: { inDropdown: true },
                textAlign: { inDropdown: true },
                link: { inDropdown: true },
                history: { inDropdown: true },
              }}
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              onEditorStateChange={this.onDraftEditorStateChange}
              wrapperStyle={{
                borderWidth: 1,
                borderStyle: "solid",
                borderRadius: 7,
                padding: 10,
              }}
            />
          </div>
          <div
            style={{
              fontFamily: "Arial, Helvetica, sans-serif",
              fontSize: 16,
              color: "#696969",
              width: "90%",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: 40,
            }}
          >
            <p>
              <em>It's as easy as 1, 2, 3!</em>
            </p>
            <ol>
              <li>
                On your phone and/or tablet, download{" "}
                {this.state.appPublishedName} at &nbsp;
                <a href={this.state.appleUrl} target="_blank">
                  App Store
                </a>{" "}
                or{" "}
                <a href={this.state.androidUrl} target="_blank">
                  Android/Google Play
                </a>
              </li>
              <li>
                Click “Create New Patient Account” -- Fill in your email, create
                a password and add your name
              </li>
              <li>
                Click “I Agree” after reading the Privacy Policy and Terms of
                Agreement
              </li>
            </ol>
            <p>
              That's it! Now you're ready for your next visit. We look forward
              to seeing you!
            </p>
            <p>
              <strong>Don't have a smart phone or tablet? No problem!</strong>
            </p>
            <p>
              You can now use {this.state.appPublishedName} on the web too!
              Visit us at{" "}
              <a href={this.state.portalUrl}>{this.state.portalUrl}</a> and use
              the "Create New Account" feature to sign up!
            </p>
          </div>
          <div style={{ clear: "both", width: "100%", textAlign: "center" }}>
            <a href={this.state.appleUrl}>
              <img
                src="https://system-data.s3-us-west-2.amazonaws.com/resources/images/app-store-button.png"
                alt="App Store Icon"
                style={{ width: 150 }}
              />
            </a>
            <a href={this.state.androidUrl}>
              <img
                src="https://system-data.s3-us-west-2.amazonaws.com/resources/images/google-play-button.png"
                alt="Play Store Icon"
                style={{ width: 150 }}
              />
            </a>
          </div>
          <div style={{ clear: "both", width: "100%", textAlign: "center" }}>
            <img
              src="https://system-data.s3-us-west-2.amazonaws.com/resources/logo/ac-logo-text.png"
              alt="AC Health Logo"
              style={{
                width: 150,
                borderRadius: 9,
                padding: 10,
                backgroundColor: colors.primary,
                display:
                  this.state.appPublishedName === "AC Health"
                    ? "inline"
                    : "none",
              }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            justifyContent: "flex-end",
            margin: 20,
            marginRight: 40,
          }}
        >
          <Button variant="outlined" onClick={() => this.saveAndGoBack()}>
            Save Welcome Email Template
          </Button>
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, whiteLabelSettings }) {
  return {
    userId: user.userId,
    user,
    apps,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditAppWelcomeEmail);



// WEBPACK FOOTER //
// ./src/layout/EditAppWelcomeEmail.js